<!-- 
  © 2025 Ananda Kumar. All rights reserved.
  Unauthorized copying of this file, via any medium, is strictly prohibited.
-->
<div class="menu-bar-container m-0 pb-0">
    <h6 class="text-start t-header-text mb-3 pt-0">Kith & Kin</h6>
    <div class="menu-bar-card">
        <a class="menu-item" *ngFor="let item of menuItems" [routerLink]="tenantService.getTenantPrefixedPath(item.routeUrl)" routerLinkActive="active"
            #rla="routerLinkActive" [routerLinkActiveOptions]="{ exact: true }">
            <i class="menu-icon" [class]="item.icon" [class.active-icon]="rla.isActive"></i>
            <p class="menu-label t-text-primary">{{ item.label }}</p>
        </a>
    </div>
</div>